// extracted by mini-css-extract-plugin
module.exports = {"root":"ExternalDnsAddForm_root__2P3UD","natTarget":"ExternalDnsAddForm_natTarget__brw0h","asset":"ExternalDnsAddForm_asset__1eH0E","hostname":"ExternalDnsAddForm_hostname__3PstH"};